<template>
  <section id="about" class="about-section">
    <div class="container">
      <div class="section-header">
        <span class="section-badge">מי אנחנו</span>
        <h2 class="section-title">יבוא ושיווק מזון ברמה אחרת</h2>
        <p class="section-subtitle">
          GoFood היא חברת יבוא ושיווק מזון מובילה בישראל, המתמחה במוצרי צריכה מהירה ומותגים
          בינלאומיים
        </p>
      </div>

      <div class="about-grid">
        <div class="about-card">
          <div class="about-icon">
            <svg
              viewBox="0 0 24 24"
              width="28"
              height="28"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
            >
              <circle cx="12" cy="12" r="10" />
              <path
                d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"
              />
            </svg>
          </div>
          <h3 class="about-title">יבוא גלובלי</h3>
          <p class="about-desc">
            מייבאים מוצרי מזון איכותיים מספקים מובילים בעולם, עם דגש על טריות ואיכות ללא פשרות
          </p>
        </div>

        <div class="about-card">
          <div class="about-icon">
            <svg
              viewBox="0 0 24 24"
              width="28"
              height="28"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
            >
              <line x1="12" y1="1" x2="12" y2="23" />
              <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
            </svg>
          </div>
          <h3 class="about-title">מחירים תחרותיים</h3>
          <p class="about-desc">
            עבודה ישירה מול יצרנים ויבוא בכמויות גדולות מאפשרים לנו להציע מחירים אטרקטיביים
          </p>
        </div>

        <div class="about-card">
          <div class="about-icon">
            <svg
              viewBox="0 0 24 24"
              width="28"
              height="28"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
            >
              <rect x="1" y="3" width="15" height="13" />
              <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
              <circle cx="5.5" cy="18.5" r="2.5" />
              <circle cx="18.5" cy="18.5" r="2.5" />
            </svg>
          </div>
          <h3 class="about-title">צי משלוחים</h3>
          <p class="about-desc">
            צי משאיות מודרני המבטיח משלוחים מהירים ואמינים לכל נקודה בישראל, כולל אזורים מרוחקים
          </p>
        </div>

        <div class="about-card">
          <div class="about-icon">
            <svg
              viewBox="0 0 24 24"
              width="28"
              height="28"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
            >
              <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
            </svg>
          </div>
          <h3 class="about-title">סוכני שטח</h3>
          <p class="about-desc">
            צוות סוכני שטח מקצועי ומנוסה המלווה את הלקוחות ומספק שירות אישי ומותאם
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<style src="./styles/section-header.css" scoped></style>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-md);
}

@media (min-width: 768px) {
  .container {
    padding: 0 var(--spacing-lg);
  }
}

.about-section {
  padding: var(--spacing-xl) 0;
}

@media (min-width: 768px) {
  .about-section {
    padding: var(--spacing-3xl) 0;
  }
}

.about-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--spacing-md);
}

@media (min-width: 768px) {
  .about-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--spacing-lg);
  }
}

.about-card {
  padding: var(--spacing-lg);
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-lg);
  transition: all var(--transition-fast);
}

@media (min-width: 768px) {
  .about-card {
    padding: var(--spacing-xl);
  }
}

.about-card:hover {
  border-color: rgba(245, 158, 11, 0.4);
  box-shadow: 0 8px 24px rgba(245, 158, 11, 0.15);
  transform: translateY(-4px);
}

.about-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.12) 0%, rgba(217, 119, 6, 0.12) 100%);
  border-radius: var(--border-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d97706;
  margin-bottom: var(--spacing-sm);
}

@media (min-width: 768px) {
  .about-icon {
    width: 56px;
    height: 56px;
    margin-bottom: var(--spacing-md);
  }
}

.about-title {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  margin-bottom: var(--spacing-xs);
}

@media (min-width: 768px) {
  .about-title {
    font-size: var(--font-size-lg);
    margin-bottom: var(--spacing-sm);
  }
}

.about-desc {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  line-height: 1.7;
  margin: 0;
}
</style>
